// Overview mock — realistic platform-wide numbers for the cockpit screen.
// These numbers stay stable across renders (no random) so snapshots are predictable.

import type { OverviewStats } from "./types";

export function mockOverview(): OverviewStats {
  return {
    customers: {
      total: 1280,
      new_this_month: 64,
      by_status: { active: 980, new: 120, inactive: 180 },
      premium: 210,
    },
    merchants: {
      total: 48,
      total_clients: 1280,
    },
    agreements: {
      active: 540,
      new_this_month: 38,
      outstanding_debt: "742150000.00",
    },
    overdue: {
      count: 73,
      amount: "58420000.00",
    },
    money: {
      circulating: "1850000000.00",
      profit: "196000000.00",
    },
    // Last 6 months — January through June 2026, contracts and turnover growing.
    series: [
      { month: "2026-01", contracts: 68,  turnover: "245000000.00" },
      { month: "2026-02", contracts: 74,  turnover: "271000000.00" },
      { month: "2026-03", contracts: 81,  turnover: "298000000.00" },
      { month: "2026-04", contracts: 88,  turnover: "315000000.00" },
      { month: "2026-05", contracts: 95,  turnover: "338000000.00" },
      { month: "2026-06", contracts: 103, turnover: "362000000.00" },
    ],
    recent: {
      notifications: [
        {
          id: 1,
          title: "Yangi kredit imkoniyatlari haqida",
          recipients: "Barcha mijozlar",
          status: "sent",
          date: "2026-06-15T10:30:00Z",
        },
        {
          id: 2,
          title: "Tizim texnik ishlar haqida ogohlantirish",
          recipients: "Premium mijozlar",
          status: "sent",
          date: "2026-06-14T08:00:00Z",
        },
        {
          id: 3,
          title: "Yangi savdogar shartnomalar",
          recipients: "Barcha savdogarlar",
          status: "sent",
          date: "2026-06-13T14:15:00Z",
        },
        {
          id: 4,
          title: "Iyul oyi aksiya haqida",
          recipients: "Barcha mijozlar",
          status: "scheduled",
          date: "2026-07-01T09:00:00Z",
        },
        {
          id: 5,
          title: "Kredit limiti oshirilganligi haqida",
          recipients: "Aktiv mijozlar",
          status: "sent",
          date: "2026-06-12T11:45:00Z",
        },
      ],
      customers: [
        { id: 1201, name: "Jasur Toshmatov",   date_joined: "2026-06-15T09:22:00Z" },
        { id: 1202, name: "Nilufar Karimova",  date_joined: "2026-06-14T16:05:00Z" },
        { id: 1203, name: "Bobur Yusupov",     date_joined: "2026-06-14T11:33:00Z" },
        { id: 1204, name: "Sabina Razzaqova",  date_joined: "2026-06-13T08:47:00Z" },
        { id: 1205, name: "Doniyor Ergashev",  date_joined: "2026-06-12T15:20:00Z" },
      ],
    },
  };
}
